'use strict';
const PosterFrames = (() => {
 const all = [
  {id:'unframed',name:'Unframed',label:'Unframed print',description:'Print only'},
  {id:'black',name:'Black',label:'Black frame',description:'Wood frame'},
  {id:'red-oak',name:'Red Oak',label:'Red Oak frame',description:'Wood frame'},
  {id:'white',name:'White',label:'White frame',description:'Wood frame'}
 ];
 const has=id=>all.some(frame=>frame.id===id);
 const get=id=>all.find(frame=>frame.id===id)||all[0];
 // Framed retail prices approved October 18, 2026; checkout activation remains separate.
 const prices={unframed:{compact:44.95,large:59.95},black:{compact:99.95,large:149.95},'red-oak':{compact:99.95,large:149.95},white:{compact:99.95,large:149.95}};
 function price(size,frame='unframed'){
  if(!has(frame)||!['compact','large'].includes(size))throw new Error('Choose a valid poster size and frame.');
  return prices[frame][size];
 }
 function choices(selected,custom=false){
  return '<div class="poster-frame-choices" role="group" aria-label="Poster frame">'+all.map(frame=>`<button type="button" ${custom?'data-custom-frame':'data-frame'}="${frame.id}" aria-pressed="${frame.id===selected}" aria-label="${frame.label}"><span class="frame-swatch frame-swatch-${frame.id}" aria-hidden="true"></span><strong>${frame.name}</strong><small>${frame.description}</small></button>`).join('')+'</div>';
 }
 return {all,has,get,price,prices,choices};
})();
if(typeof module!=='undefined')module.exports=PosterFrames;
